// extracted by mini-css-extract-plugin
module.exports = {"frame_outer":"Frame_frame_outer__2cLOD","frame_inner":"Frame_frame_inner__6UYhn"};